export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        const type = this.application.applicationType.slug;
        this.isAws = type === 'aws';
        this.isSaaspassDemo = type === 'saaspass-demo';
        this.isSaaspassMySqlConnector = type === 'saaspass-my-sql-connector';
        this.isCustom = type === 'custom';
        this.isDropbox = type === 'dropbox';
        this.isEPM = type === 'enterprise-password-manager';
        this.isOffice365 = type === 'office-365';
        this.isSRA = type === 'saaspass-secure-remote-access';
        this.isSaml = this.application.applicationType.saml;
        this.isComputerLogin = type === 'computer-login' || type === 'computer-protection-without-ad';
    }

    showUserButtons() {
        return this.$state.is('company.manage-application.users');
    }

    showRoleButton() {
        return this.$state.is('company.manage-application.roles');
    }
    showRemoteAppButton() {
    	return this.$state.is('company.manage-application.remote-app-access');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/manage-application.controller.js